// extracted by mini-css-extract-plugin
export default {"text":"TripTips_text__Fzd8d","container":"TripTips_container__BZnwv"};